import {httpRequest} from "../../../utils/HttpRequest";
import {IBranchSearch,IBranchDetail,IBranchInsert,IBranchUpadata} from "./dataBranchTypes"
import {IPage} from "../../../types/FmsTypes";

class BranchService {
    async page(params:IBranchSearch){
        const apiUrl = "/mdm/branch/page"
        return await httpRequest.post<IPage<IBranchDetail>>(apiUrl,params)
    }
    async insert(params:IBranchInsert){
        const apiUrl = "/mdm/branch/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async updata(params:IBranchUpadata){
        const apiUrl = "/mdm/branch/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async remove(catalog:string,code:string){
        const apiUrl = `/mdm/branch/remove/${catalog}/${code}`
        return await httpRequest.post<boolean>(apiUrl)
    }
}
const branchService = new BranchService()
export {
    branchService
}